import { Component, input, output } from '@angular/core';
import { IconModule } from '../icon/icon.module';

@Component({
	selector: 'ui-removable-filter-button',
	templateUrl: './removable-filter-button.component.html',
	imports: [IconModule],
})
export class RemovableFilterButtonComponent {
	tabIndex = input<number>(0);
	hideRemoveButton = input<boolean>(false);
	disabled = input<boolean>(false);
	styleClass = input<string>('');

	removeClick = output<void>();
}
